import * as actionTypes from "./constant";

const initialState = {
  processing: false,
  error: false,
  userList: [],
  userCount: 0,
  fieldUserList: [],
  fieldUSerCount: 0,
  userReportData:[],
  circleList: [],
  regionList:[],
  pincodeList: [],
  userEditStatus: false,
  addUserStatus : false,

};

export default function UserReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_USER_SUCCESS_ACTION:
      return {
        ...state,
        userList: action.payload.users,
        userCount: action.payload.totalCount,
      };
    case actionTypes.FETCH_FIELDUSER_SUCCESS_ACTION:
      return {
        ...state,
        fieldUserList: action.payload.users,
        fieldUSerCount: action.payload.totalCount,
      };
    case actionTypes.FETCH_USERID_SUCCESS_ACTION:
      return {
        ...state,
        userList: state.userList.map((list) =>
          list.id === action.payload.id ? action.payload : list
        ),
        userCount: state.userCount,
      };
    case actionTypes.CHANGE_STATUS_USER_SUCCESS_ACTION:
      return {
        ...state,
        // userList: state.userList.map((list) =>
        //   list.id === action.payload.id ? action.payload : list
        // ),
        // userCount: state.userCount,
      };

      case actionTypes.FETCH_USER_REPORT_SUCCESS_ACTION:
        return {
          ...state,
          userReportData: action.payload.users,
        };

        case actionTypes.FETCH_USER_REPORT_INIT_ACTION:
          return {
            ...state,
            userReportData: action.payload,
          };
      case actionTypes.FETCH_CIRCLE_NAME_SUCCESS_ACTION:
        return{
          ...state,
          circleList: action.payload.circle,
        }

      case actionTypes.FETCH_REGION_NAME_SUCCESS_ACTION:
        
        return{
          ...state,
          regionList: action.payload.regions
        }
     
      case actionTypes.FETCH_PINCODS_SUCCESS_ACTION:
        return{
          ...state,
          pincodeList: action.payload.pin
        }
      case actionTypes.EDIT_USER_SUCCESS_ACTION:
        return{
          ...state,
          userEditStatus: action.payload
        }
      case actionTypes.ADD_USER_SUCCESS_ACTION:
        return{
          ...state,
          addUserStatus: action.payload
        }
    default:
      return {
        ...state,
      };
  }
}
